import { getFullUrlPure } from 'hubspot-url-utils/pure';
import * as ClassicHublets from 'hubspot-url-utils/hublets';
import * as Hublets from 'hubspot-url-utils/hublets-next';
import { MagpieConfigManager } from '../models/config/config-manager';

type GetFullUrlPureArgs = Parameters<typeof getFullUrlPure>;
type GetFullUrlPureReturn = ReturnType<typeof getFullUrlPure>;

const curriedGetOrigin =
  (subdomain: GetFullUrlPureArgs[0]) =>
  (env: GetFullUrlPureArgs[2]) =>
  (hublet: GetFullUrlPureArgs[1]): GetFullUrlPureReturn =>
    getFullUrlPure(subdomain, hublet, env);

// TODO: replace hardcoding the preview origin with api.hubspotqa.com/cos-domains/v1/internal/preview-domain
const getPreviewOrigin =
  (portalId: string, isQA: boolean) =>
  (hublet: GetFullUrlPureArgs[1]): string =>
    `https://${portalId}.hubspotpreview${isQA ? 'qa' : ''}-${hublet}.com`;

const getPreviewV2Origin =
  (portalId: string, isQA: boolean) =>
  (hublet: GetFullUrlPureArgs[1]): string =>
    `https://${portalId}.hubspotpreview${isQA ? 'qa2' : '2'}-${hublet}.com`;

export const getAllowedOrigins = () => {
  const classicHublets = Object.values(ClassicHublets);
  const hublets = Object.values(Hublets);

  const getLocal = curriedGetOrigin('local');
  const getApp = curriedGetOrigin('app');
  const getLocalQA = getLocal('qa');
  const getAppQA = getApp('qa');
  const getLocalProd = getLocal('prod');
  const getAppProd = getApp('prod');
  const portalId = MagpieConfigManager.getInstance().get('portalId');

  const localQa = classicHublets.map(getLocalQA);
  const qa = classicHublets.map(getAppQA);
  const localProd = hublets.map(getLocalProd);
  const prod = hublets.map(getAppProd);

  const localTestEnv = 'https://local.hsappstatic.net';
  const staticTestEnv = 'https://static.hsappstatic.net';

  const previewOrigins = portalId
    ? [
        ...hublets.map(getPreviewOrigin(portalId, false)),
        ...hublets.map(getPreviewOrigin(portalId, true)),
        ...hublets.map(getPreviewV2Origin(portalId, false)),
        ...hublets.map(getPreviewV2Origin(portalId, true)),
      ]
    : [];

  return [
    ...localQa,
    ...qa,
    ...localProd,
    ...prod,
    ...previewOrigins,
    localTestEnv,
    staticTestEnv,
  ];
};
